var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.21631H16C16.5304 4.21631 17.0391 4.42702 17.4142 4.80209C17.7893 5.17717 18 5.68588 18 6.21631V20.2163",
    stroke: "#FF95B4",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.2163H5",
    stroke: "#FF95B4",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.2163H22",
    stroke: "#FF95B4",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.2163V12.2263",
    stroke: "#FF95B4",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.77826V20.9353C13 21.0872 12.9653 21.2371 12.8987 21.3736C12.8321 21.5101 12.7352 21.6296 12.6155 21.7231C12.4958 21.8166 12.3564 21.8816 12.2078 21.9132C12.0592 21.9447 11.9054 21.942 11.758 21.9053L5 20.2163V5.77826C5.00007 5.33227 5.1492 4.8991 5.42371 4.54759C5.69821 4.19609 6.08232 3.94641 6.515 3.83826L10.515 2.83826C10.8098 2.76459 11.1174 2.75903 11.4146 2.82202C11.7118 2.885 11.9908 3.01487 12.2303 3.20178C12.4699 3.38868 12.6637 3.62769 12.797 3.90068C12.9304 4.17366 12.9998 4.47444 13 4.77826Z",
    stroke: "#FF95B4",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDoor);
export default __webpack_public_path__ + "static/media/openDoor.537116d8ab2522fdd77087a1e8a8e1a3.svg";
export { ForwardRef as ReactComponent };